var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadSetPhonesCustomerService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#ffffff;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#ffffff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#ffffff;stroke-width:2;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,17v-3C5,7.9,9.9,3,16,3s11,4.9,11,11v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,17c0,5.5-4,10.1-9.3,10.9C16.8,28,16,27.3,16,26.4v0c0-0.8,0.6-1.4,1.4-1.4h0c0.9,0,1.6,0.7,1.6,1.6V27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,13c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4V13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,21c2.2,0,4-1.8,4-4c0-2.2-1.8-4-4-4V21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadSetPhonesCustomerService);
export default __webpack_public_path__ + "static/media/head-set-phones-customer-service.bde63ccc64765c2e97f19d09a4129f3f.svg";
export { ForwardRef as ReactComponent };